const DOCUMENTS_FILE_EXTENTIONS = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'ppt'];
const VIDEO_FILE_EXTENTIONS = ['mp4', 'webm', 'avi'];
const ALL_FILE_EXTENTIONS = [...DOCUMENTS_FILE_EXTENTIONS, ...VIDEO_FILE_EXTENTIONS];

export { DOCUMENTS_FILE_EXTENTIONS, VIDEO_FILE_EXTENTIONS, ALL_FILE_EXTENTIONS };
